import PropertyDetailContract from './PropertyDetailContract.vue';

export default PropertyDetailContract;